import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import Layout from "./components/common/Layout";
import Home from "./pages/Home";
import Cart from "./pages/CartPage";
import Product from "./pages/Product";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import PrayList from "./pages/PrayList";
import BuddhismDetail from "./pages/BuddhismDetail";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import MyPage from "./pages/MyPage";
import MyOrdersPage from "./pages/MyOrdersPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import AboutPage from "./components/about/AboutPage"; // AboutPage 임포트 추가
import NoticeList from './pages/NoticeList';
import NoticeDetail from './pages/NoticeDetail';
import NoticeWrite from './pages/NoticeWrite';
import QnaList from './pages/QnaList';
import QnaWrite from './pages/QnaWrite';
import BuddhistCalendar from './pages/BuddhistCalendar';
import ScrollToTop from './components/common/ScrollToTop';
import Community from './pages/Community';
import CommunityDetail from './pages/CommunityDetail';
import LivePrayPage from './pages/LivePrayPage';
import TempleAdminList from './pages/TempleAdminList';
import TempleAdmin from './pages/TempleAdmin';
import AdminOrders from './pages/AdminOrders';
import AdminUsers from './pages/AdminUsers';

// 인증 여부 확인 함수
const isAuthenticated = () => {
  const token = localStorage.getItem("accessToken");
  return !!token;
};

// 보호된 라우트 컴포넌트
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Layout으로 감싸진 라우트들 */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/pray" element={<PrayList />} />
            <Route path="/buddhism/:id" element={<BuddhismDetail />} />
            <Route path="/order-success" element={<OrderSuccessPage />} />
            <Route path="/buddhist-calendar" element={<BuddhistCalendar />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/cart"
              element={
                <ProtectedRoute>
                  <Cart />
                </ProtectedRoute>
              }
            />
            <Route path="/mypage" element={<MyPage />} />
            <Route path="/my-orders" element={<MyOrdersPage />} />
            <Route path="/my-orders/:orderId" element={<OrderDetailPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/about" element={<AboutPage />} /> {/* AboutPage 라우트 추가 */}

                {/* 게시판 관련 라우트 추가 */}
                <Route path="/notice" element={<NoticeList />} />
            <Route path="/notice/write" element={<NoticeWrite />} />
            <Route path="/notice/edit/:id" element={<NoticeWrite />} />
            <Route path="/notice/:id" element={<NoticeDetail />} />
            <Route path="/qna" element={<QnaList />} />
            <Route path="/qna/write" element={<QnaWrite />} />
                {/* 불교 모임 라우트 추가 */}
            <Route path="/community" element={<Community />} />
            <Route path="/community/:id" element={<CommunityDetail />} />
            <Route path="/live" element={<LivePrayPage />} />
            {/* 사찰 관리자 라우트 */}
            <Route path="/admin/temples" element={<ProtectedRoute><TempleAdminList /></ProtectedRoute>} />
            <Route path="/admin/orders" element={<ProtectedRoute><AdminOrders /></ProtectedRoute>} />
            <Route path="/admin/temples/write" element={<ProtectedRoute><TempleAdmin /></ProtectedRoute>} />
            <Route path="/admin/temples/edit/:id" element={<ProtectedRoute><TempleAdmin /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
          </Route>

          {/* Layout으로 감싸지지 않는 라우트들 (로그인, 회원가입 등) */}
        
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
